import { render, staticRenderFns } from "./ProgramTrainingComponent.vue?vue&type=template&id=b6dd2676&scoped=true"
import script from "./ProgramTrainingComponent.vue?vue&type=script&lang=js"
export * from "./ProgramTrainingComponent.vue?vue&type=script&lang=js"
import style0 from "./ProgramTrainingComponent.vue?vue&type=style&index=0&id=b6dd2676&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6dd2676",
  null
  
)

export default component.exports